import { useCallback } from "react";
import { TextCell } from "./TextCell";
import { jsx as _jsx } from "react/jsx-runtime";
export function FloatCell(props) { var _onChange = props.onChange; var onChange = useCallback(function (value, extra) { try {
    var n = parseFloat(value);
    if (isNaN(n))
        throw new Error("invalid");
    _onChange(n, extra);
}
catch (e) {
    _onChange(0, extra);
} }, [_onChange]); return /*#__PURE__*/ _jsx(TextCell, { align: "right", value: typeof props.value === "number" ? props.value.toFixed(3) : props.value, onCancel: props.onCancel, onChange: onChange }); }
